import { useAsyncData } from '#imports'
import type { Ref } from 'vue'

import { getAsyncDataKey } from '@backmarket/nuxt-module-http-v2/getAsyncDataKey'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import type {
  ComparisonData,
  ErrorData,
} from '../useEnrichResultsPage/useEnrichResultsPage.types'

export function useFetchResultsPage(model1: Ref<string>, model2: Ref<string>) {
  const $httpFetch = useHttpFetch()

  return useAsyncData<ComparisonData, ErrorData>(
    () =>
      getAsyncDataKey('models-comparison-v2', {
        slug1: model1.value,
        slug2: model2.value,
      }),
    () =>
      $httpFetch('/product-page/compare/:model1/:model2', {
        pathParams: { model1: model1.value, model2: model2.value },
        ...(import.meta.client && { query: { strict_order: false } }),
      }),
    { getCachedData: (key, nuxtApp) => nuxtApp.payload.data[key] },
  )
}
